/**
 * Shared wrapper for /terms /privacy /refund-policy.
 *
 * Renders a consistent legal-page chrome: title, version banner, footer
 * disclaimer that the page is an engineer-authored v1.0 draft pending
 * legal review (Compliance Baseline / STA-128).
 */

import React from 'react';

export function LegalPage({
  title,
  version,
  lastUpdated,
  children,
}: {
  title: string;
  version: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  return (
    <article className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl text-tarot-gold mb-2">{title}</h1>
      <p className="text-tarot-muted text-sm mb-8">
        版本：{version}　·　最後更新：{lastUpdated}
      </p>
      <div className="space-y-8 text-tarot-text leading-relaxed">{children}</div>
      <p className="text-xs text-tarot-muted mt-12 italic border-t border-tarot-purple/20 pt-6">
        ⚠️ 本文件為工程師依一般網路服務常見條款及《消費者保護法》之初稿，並非執業律師意見。正式上線前將由律師審閱後發行正式版。
      </p>
    </article>
  );
}

export function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section>
      <h2 className="text-xl text-tarot-gold mb-3">{title}</h2>
      <div className="[&_ul]:list-disc [&_ul]:pl-6 [&_li]:my-1 space-y-3">
        {children}
      </div>
    </section>
  );
}
